module.exports = __webpack_public_path__ + "media/img/frontend_application/todo-empty-32d20a483eacbe52469f6748ee9a45da.png";